// ROUTES
export const ROUTE_LIST = 'admin2.ira.list';

// CLAIM
export const CLAIM_IRA_EDIT = 'admin.payor.edit'; // API needs to change this to 'admin.ira.edit'

// STORAGE KEYS
export const IRA_LIST_STORAGE_KEY = 'admin-ira-list';
export const IRA_LIST_VIEW_KEY = 'tv-admin-ira-list';

// TABLE ID
export const IRA_LIST_TABLE_ID = 'adminIraList';

// IMPORT
export const IRA_EFFECTIVE_YEAR_START = '2026';
